import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=e674ef92&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=e674ef92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e674ef92",
  null
  
)

export default component.exports